/* globals jQuery */

const carouselBanners = new WeakMap();

const carouselBannerObserver = new IntersectionObserver( changes => {
	changes.forEach( change => {
		const config = carouselBanners.get( change.target );
		if ( change.isIntersecting && ! config.timeout ) {
			config.timeout = config.advance();
		} else {
			clearInterval( config.timeout );
			config.timeout = null;
		}
	} );
} );

function setupCarouselBanner( carousel ) {
	const interval = parseInt( carousel.dataset.interval ?? 10000 );
	const duration = interval / 2;
	const delay = interval / 2;

	carousel.style.setProperty( '--carousel-banner-interval', `${ interval }ms` );
	carousel.style.setProperty( '--carousel-banner-duration', `${ duration }ms` );
	carousel.style.setProperty( '--carousel-banner-delay', `${ delay }ms` );

	const items = [ ...carousel.querySelectorAll( '.js-carousel-banner-slide' ) ];

	const itemCount = items.length;

	carousel.append( ...items.map( item => item.cloneNode( true ) ) );

	let current = 0;
	function advance() {
		if ( current >= itemCount + 1 ) {
			carousel.style.setProperty( '--carousel-banner-duration', '0ms' );
			carousel.style.setProperty( '--carousel-banner-delay', '0ms' );
			current = 1;
			carousel.style.setProperty( '--carousel-banner-offset', current );
			void carousel.offsetWidth; // force reset
			carousel.style.setProperty( '--carousel-banner-duration', `${ duration }ms` );
			carousel.style.setProperty( '--carousel-banner-delay', `${ delay }ms` );
		}

		current++;
		carousel.style.setProperty( '--carousel-banner-offset', current );
		return setTimeout( advance, interval );
	}

	carouselBanners.set( carousel, {
		advance,
		timeout: null,
	} );

	carouselBannerObserver.observe( carousel );
}

jQuery( () => {
	document.querySelectorAll( '.js-carousel-banner' ).forEach( setupCarouselBanner );
} );
